module.exports = __webpack_public_path__ + "lisa mandel.jpg?96ebf4f952c4c7d908b615445f256611";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lisa mandel.jpg
// module id = 193
// module chunks = 0